
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Teeth_order_in_children",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Teeth_order_in_children.vue